import React from 'react';
import {Route} from 'react-router-dom';
import AsyncPage from './async';

export default [
  <Route
    key="/business/products/beauty-agent-ai-beauty-advisor"
    path="business/products/beauty-agent-ai-beauty-advisor"
    element={<AsyncPage />}
  />,
];
